
export function frac2pct(numerator: number, denominator: number, rounding?: number): number {
  return roundNumber(100 * numerator / denominator, rounding || 2);
}

export function add(a: number, b: number): number { return a + b; }

export function roundNumber(n: number, digits: number = 0): number {
  return roundNum(n, digits || 0);
}
function roundNum(n: number, digits: number): number {
  const multiple = Math.pow(10, digits);
  return Math.round(n * multiple) / multiple;
}



// WEBPACK FOOTER //
// ./src/lib/number.ts